<template>
  <Btn
    tag="button"
    :size="size"
    :variant="variant"
    :in-group="inGroup"
    :icon="buttonIcon"
    title="Copy"
    data-copy-button="copy-btn"
    @click="copy"
  />
</template>
<script lang="ts" setup>
import { copyStringToClipboard } from '~/lib/services/helpers';
import { Variant } from '~/store/_types';
import { useStore3 } from '~/store/main';
import Btn from '~/components/form/Btn.vue';
import type { FormSize, MsIcon } from '~/lib/services/types';
import { ref } from 'vue';
const buttonIcon = ref<MsIcon>('copy');

const store3 = useStore3();
const props = withDefaults(
  defineProps<{
    value?: string;
    inGroup?: boolean;
    size?: FormSize;
    variant?: Variant;
  }>(),
  { value: undefined, size: 'xs', variant: Variant.white, inGroup: false },
);

const copy = () => {
  if (props.value) {
    copyStringToClipboard(props.value ?? '');
    store3.setFlash({
      variant: Variant.info,
      text: 'Value copied to clipboard',
    });
    buttonIcon.value = 'tick';
    setTimeout(() => {
      buttonIcon.value = 'copy';
    }, 1500);
  }
};
</script>
